import React from 'react';
import { IImageRepositoryItem } from './types';
import Checkbox from '../Inputs/Checkbox';

interface ImageRepositoryItemProps {
  item: IImageRepositoryItem;
  selected: boolean;
  onSelect: (selected: boolean) => void;
}

const ImageRepositoryListItem = ({
  item,
  selected,
  onSelect,
}: ImageRepositoryItemProps) => {
  const onItemClick = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    const target: HTMLElement | undefined = e.target as any;
    const tagName = target?.tagName?.toLowerCase();
    if (tagName != 'img' && tagName != 'a') {
      onSelect(!selected);
    }
  };

  return (
    <button
      className="grid grid-cols-5 items-center gap-4 text-left"
      onClick={onItemClick}
    >
      <div className="flex shrink">
        <a href={item.fullImageUrl} target="_blank" rel="noreferrer">
          <img
            className="flex aspect-square w-14 object-contain"
            src={item.imageUrl}
          />
        </a>
      </div>
      <div className="col-span-2 flex flex-1">{item.name}</div>
      <div className="flex flex-1">{item.fileSize}</div>
      <div className="flex flex-1 justify-center">
        <Checkbox
          type="checkbox"
          checked={selected}
          onChange={(e) =>
            e.target.checked != selected && onSelect(e.target.checked)
          }
        />
      </div>
    </button>
  );
};

export default ImageRepositoryListItem;
